import * as React from "react";
import {
  Card,
  CardContent,
  CardActions,
  Avatar,
  TextField,
  Button,
  Typography,
  Box,
  Modal,
  Container,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { styled } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const Input = styled("input")({
  display: "none",
});

const Profile = () => {
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const [profile, setProfile] = useState({
    name: user?.name || "",
    email: user?.email || "",
    role: user?.role || "",
    profileImageUrl: user?.profileImageUrl || "",
    address: user?.address || "",
    contact: user?.contact || "",
    profileImage: null,
  });

  const [changePasswordForm, setChangePasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profileImage") {
      if (files.length > 0) {
        const file = files[0];
        setProfile({ ...profile, profileImage: file });
        setSelectedFile(file.name);
      }
    } else {
      setProfile({ ...profile, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(profile).forEach((key) => {
      if (key === "profileImage" && profile.profileImage) {
        formData.append("profileImage", profile.profileImage);
      } else {
        formData.append(key, profile[key]);
      }
    });

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/${user._id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );
      const data = await response.json();
      if (response.ok) {
        setUser(data);
        handleClose();
      } else {
        console.error("Update failed:", data.message);
      }
    } catch (error) {
      console.error("Failed to update user:", error);
    }
  };

  const handleChangePasswordChange = (e) => {
    const { name, value } = e.target;
    setChangePasswordForm({ ...changePasswordForm, [name]: value });
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(changePasswordForm),
        }
      );
      const data = await response.json();
      if (response.ok) {
        console.log(data.message);
        setChangePasswordForm({ currentPassword: "", newPassword: "" });
      } else {
        console.error("Change password failed:", data.message);
      }
    } catch (error) {
      console.error("Failed to change password:", error);
    }
  };

  return (
    <Container sx={{ mt: 12 }}>
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Profile" />
          <Tab label="Change Password" />
        </Tabs>
      </Box>
      {activeTab === 0 && (
        <Grid justifyContent="flex-start">
          <Card sx={{ maxWidth: 345, m: "auto", mt: 2 }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                {profile.profileImageUrl ? (
                  <Avatar
                    src={profile.profileImageUrl}
                    sx={{
                      width: 256,
                      height: 256,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "secondary.main",
                      width: 56,
                      height: 56,
                    }}
                  >
                    {profile.name[0]}
                  </Avatar>
                )}
              </Box>
              <Typography gutterBottom variant="h5" component="div">
                {profile.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Role: {profile.role}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Email: {profile.email}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Address: {profile.address}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Contact: {profile.contact}
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small" variant="outlined" onClick={handleOpen}>
                Edit
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={() => navigate("/myorders")}
              >
                My Orders
              </Button>
            </CardActions>
          </Card>
        </Grid>
      )}
      {activeTab === 1 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 2,
          }}
        >
          <TextField
            margin="normal"
            required
            label="Current Password"
            name="currentPassword"
            type="password"
            value={changePasswordForm.currentPassword}
            onChange={handleChangePasswordChange}
            sx={{ width: "100%", maxWidth: 400 }}
          />
          <TextField
            margin="normal"
            required
            label="New Password"
            name="newPassword"
            type="password"
            value={changePasswordForm.newPassword}
            onChange={handleChangePasswordChange}
            sx={{ width: "100%", maxWidth: 400 }}
          />
          <Button
            size="large"
            variant="outlined"
            onClick={handleChangePassword}
            sx={{ width: "100%", maxWidth: 400, mt: 2 }}
          >
            Change Password
          </Button>
        </Box>
      )}

      {/* Edit Profile Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit Profile
          </Typography>
          <Box component="form" noValidate autoComplete="off">
            <TextField
              margin="normal"
              required
              fullWidth
              label="Full Name"
              name="name"
              value={profile.name}
              onChange={handleChange}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              name="email"
              value={profile.email}
              onChange={handleChange}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Address"
              name="address"
              value={profile.address}
              onChange={handleChange}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Contact No"
              name="contact"
              value={profile.contact}
              onChange={handleChange}
            />
            <label htmlFor="profile-image-upload">
              <Input
                accept="image/*"
                id="profile-image-upload"
                type="file"
                name="profileImage"
                onChange={handleChange}
              />
              <Button variant="outlined" component="span" sx={{ mt: 2 }}>
                Upload Image
              </Button>
              {selectedFile && (
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                  {selectedFile}
                </Typography>
              )}
            </label>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleSubmit}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default Profile;
